module.exports = __webpack_public_path__ + "static/media/icon_close.38313004.svg";